import s2_3_2_sect2_img1 from '../../../../assets/images/s2_3_2_sect2_img1.png';
import s2_3_2_sect2_img2 from '../../../../assets/images/s2_3_2_sect2_img2.png';
import s2_3_2_sect2_img3 from '../../../../assets/images/s2_3_2_sect2_img3.png';

import s2_3_2_sect3_img from '../../../../assets/images/s2_3_2_sect3_img.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 C40</p>
        </div>
        <div className="center">
          <div className="col-flex mb-5">
            <div className="row-flex-center between mb-4 m-col-flex">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_3_2_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-48 m-w-100 txt-left ">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  3중 롤러로 건습 분리 <br />한 번에 청소 완료
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  기존 듀얼 롤러 대비 2배 빠른 청소 성능
                  <br />
                  카펜과 하드 바닥도 롤러 교체 없이 연속 청소
                </p>
              </div>
            </div>
            <div className="row-flex-center between mb-10 m-col-flex">
              <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none ">
                <img src={s2_3_2_sect2_img2} alt="" />
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  세척 후 초고속 건조
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  강력한 흡입력으로 물기 없이 깔끔한 바닥 <br />
                  안전한 매장 유지
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-none">
                <img src={s2_3_2_sect2_img2} alt="" />
              </div>
            </div>
            <div className="row-flex-center between m-col-flex">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_3_2_sect2_img3} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-48 m-w-100 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  편리한 관리 기능
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  탈착식 폐수통으로 악취걱정 없이 간편한 관리 <br />
                  5초 배터리 교체로 중단 없는 청소
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="s2_1_1_sect3 pt-10">
        <div className="center">
          <div className="txt-center mb-4">
            <p className="prt-bold fs-40 fc-black1 lh-13 mb-1">4대 기능</p>

            <p className="fs-20 lh-14">
              <span className="prt-light fc- 777">
                스위핑, 흡입, 물걸레, 먼지밀기 등 매장 내 다양한 청소 고민 해결
              </span>
              <br />
              <span className="prt-semi-bold fs-20 fc-005eed">
                10개 센서 탑재, 복잡한 환경도 장애물 걱정없이 자유롭게 주행
              </span>
            </p>
          </div>

          <div className="flex-center mb-4">
            <img src={s2_3_2_sect3_img} alt="" />
          </div>
        </div>
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
